const handlerRespError = (resp, history) => {
    console.log(resp.response.data)
    let status = resp.response.status;
    if(status === 401){
        history.push("/login");
    }
};

export { handlerRespError };